import { create } from 'zustand';
import { ReportFilters, ReportFormat, ReportType } from '../types/reports.types';

interface ReportBuilderState {
  step: number;
  reportName: string;
  reportType: ReportType | null;
  filters: Partial<ReportFilters>;
  format: ReportFormat;
  setStep: (step: number) => void;
  setReportName: (name: string) => void;
  setReportType: (type: ReportType) => void;
  setFilters: (filters: Partial<ReportFilters>) => void;
  setFormat: (format: ReportFormat) => void;
  resetBuilder: () => void;
}

const initialState = {
  step: 1,
  reportName: '',
  reportType: null,
  filters: {
    dateFrom: '',
    dateTo: '',
    networkIds: [],
    metrics: [],
  },
  format: 'csv' as ReportFormat,
};

export const useReportsStore = create<ReportBuilderState>((set) => ({
  ...initialState,
  setStep: (step) => set({ step }),
  setReportName: (reportName) => set({ reportName }),
  setReportType: (reportType) => set({ reportType }),
  setFilters: (filters) => set((state) => ({ 
    filters: { ...state.filters, ...filters } 
  })),
  setFormat: (format) => set({ format }),
  resetBuilder: () => set(initialState),
}));
